import Swal from 'sweetalert2';
import CreditCardFormValidation from '../entrypoints/src/admin/components/credit_card_form_validation';
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.$cbEula = this.element.querySelector("#eula");
    this.$btnSave = this.element.querySelector(".btn#save");
    this.bindEvents();
    this.initCreditCardFormValidation();
  }

  bindEvents() {
    $('#payment-profile').on('show.bs.collapse', (ev) => {
      let radio = ev.target.closest('.card').querySelector('input[type="radio"]');
      !!radio && (radio.checked = true);

      this.updateSaveButton();
    });

    this.$cbEula.addEventListener('change', () => this.updateSaveButton());

    this.$btnSave.addEventListener('click', (ev) => {
      ev.preventDefault();

      this.element.querySelector('#payment-method-credit-card').checked && this.formValidation.validate();

      if (!this.formValidated) {
        Swal.fire({
          type: 'warning',
          title: 'Atenção',
          animation: false,
          text: 'Por favor, leia e aceite o Termo de Uso para continuar',
          footer: 'Em caso de dúvidas ou inconcordância no termo, entre em contato pelo e-mail contato@traus.com.br.'
        });

        return;
      }

      if (this.$btnSave.classList.contains('disabled'))
        return;

      AjaxLoader.show();
      this.$btnSave.closest('form').submit();
    })
  }

  initCreditCardFormValidation() {
    let _this = this;
    let unknownBrand = this.element.querySelector('[data-card-brand="unknown"]');

    this.formValidation = new CreditCardFormValidation(this.element, {
      afterValidate(valid) { _this.updateSaveButton() },
      onCardTypeChanged({type, creditCard}) {
        unknownBrand.classList.toggle('hidden', false);
        _this.element.querySelectorAll(`[data-card-brand]`).forEach((el) => { el.classList.toggle('hidden', true) });

        let brandType = !!type ? type : !!creditCard ? creditCard.card.type : 'unknown',
          brand = _this.element.querySelector(`[data-card-brand="${brandType.replace(/[-]/, '')}"]`);

        if (!brand)
          return true;

        unknownBrand.classList.toggle('hidden', true);
        brand.classList.toggle('hidden', false);
      }
    });
  }

  updateSaveButton() {
    this.$btnSave.classList.toggle('disabled', !this.formValidated);
  }

  get formValidated() {
    let $bankBill = this.element.querySelector('#payment-method-bank-bill');
    return ((!!$bankBill && $bankBill.checked) || this.formValidation.isValid) && this.$cbEula.checked;
    // return this.formValidation.isValid && this.$cbEula.checked;
  }
}